<template>
  <generic-modal :title="$t('bulk process')" ref="generic_modal">
    <div v-if="meta">
      <div class="fixed-grid">
        <div class="grid">
          <div class="cell">
            <div class="field">
              <input
                class="is-checkradio"
                type="checkbox"
                id="chk_execute_sirc"
                name="chk_execute_sirc"
                v-model="meta.execute_sirc"
              />
              <label for="chk_execute_sirc">{{ $t("execute sirc") }}</label>
            </div>
          </div>
          <div class="cell">
            <div class="field">
              <input
                class="is-checkradio"
                type="checkbox"
                id="chk_execute_sat"
                name="chk_execute_sat"
                v-model="meta.execute_sat"
              />
              <label for="chk_execute_sat">{{ $t("execute sat") }}</label>
            </div>
          </div>
          <div class="cell">
            <div class="field">
              <input
                class="is-checkradio"
                type="checkbox"
                id="chk_execute_wealth_status"
                name="chk_execute_wealth_status"
                v-model="meta.execute_wealth_status"
              />
              <label for="chk_execute_wealth_status">{{
                $t("execute wealth status")
              }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="is-divider"></div>
    <div class="columns">
      <div class="column">
        <div class="button is-rounded" @click="calculate_chunks">
          <span class="icon is-small">
            <i class="fa fa-bolt"></i>
          </span>
          <span>{{ $t("calculate bulk process") }}</span>
        </div>
      </div>
      <div class="column">
        <pre>{{ chunks_info }}</pre>
      </div>
    </div> -->
    <div v-if="meta.execute_wealth_status">
      <div class="is-divider"></div>
      <div class="title is-6">{{ $t("wealth status report information") }}</div>
      <div class="subtitle is-6">{{ $t("report date") }}</div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("day") }}</label>
            <div class="control">
              <input
                class="input"
                type="number"
                v-model="meta.wealth_status_day"
                placeholder="0"
                min="0"
                max="31"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("month") }}</label>
            <div class="control">
              <input
                class="input"
                type="number"
                v-model="meta.wealth_status_month"
                placeholder="0"
                min="0"
                max="12"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("year") }}</label>
            <div class="control">
              <input
                class="input"
                type="number"
                v-model="meta.wealth_status_year"
                placeholder="0"
                min="0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="is-divider"></div>
    <div class="field has-addons">
      <div class="control">
        <div
          class="button is-rounded"
          v-bind:class="{ 'is-active': meta.selected_start == 'manual' }"
          @click="meta.selected_start = 'manual'"
        >
          <span class="icon is-small has-text-info">
            <i class="fa fa-save"></i>
          </span>
          <span>{{ $t("save to manual process") }}</span>
        </div>
      </div>
      <div class="control">
        <div
          class="button is-rounded"
          v-bind:class="{ 'is-active': meta.selected_start == 'now' }"
          @click="meta.selected_start = 'now'"
        >
          <span class="icon is-small has-text-warning">
            <i class="fa fa-play"></i>
          </span>
          <span>{{ $t("start processing now") }}</span>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-play"></i>
        </span>
        <span>{{ $t("start") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "FactoringModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      chunks_info: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();

      setTimeout(() => {
        v.meta.wealth_status_day = new Date().getDate();
        v.meta.wealth_status_month = new Date().getMonth() + 1;
        v.meta.wealth_status_year = new Date().getFullYear();
      }, 1000);
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/factoring", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/factoring/bulk", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/factoring", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        execute_sirc: true,
        execute_sat: true,
        execute_wealth_status: true,
        selected_start: "now",
      };
      v.error = "";
      // v.uuid = "";
    },
    calculate_chunks() {
      let v = this;
      get("/factoring/bulk/calculate", {})
        .then((chunks_info) => {
          v.chunks_info = chunks_info;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
